<template>
    <div class="field">
        <label class="label">{{ label }}</label>

        <e-autocomplete
            :model-value="controlledValue"
            :data="data"
            field="title"
            :label="label"
            placeholder="Type a course title..."
            :loading="isFetching"
            clearable
            @esc="$emit('update:modelValue', null)"
            @add-new="person => $emit('addNew', person)"
            @clear="$emit('update:modelValue', null)"
            @typing="getAsyncData"
            @select="course => $emit('update:modelValue', course)"
        >
            <template #default="props">
                <span :title="props.option.title">{{ props.option.title }}</span>
            </template>
        </e-autocomplete>
    </div>
</template>

<script>
import debounce from 'lodash/debounce.js';

import axios from '@/plugins/axios.js';

export default {
    name: 'CourseSearch',

    props: {
        label: {
            type: String,
            required: false,
            default: 'Course Filter',
        },

        modelValue: {
            type: [Object, String, Number],
            required: false,
            default: null,
        },

        setValue: {
            type: String,
            required: false,
            default: null,
        },
    },

    data() {
        return {
            data: [],
            selected: null,
            isFetching: false,
        };
    },

    emits: ['update:modelValue', 'addNew'],

    computed: {
        controlledValue() {
            const v = this.modelValue;

            if (v == null || v === '') {
                return null;
            }

            return v;
        },
    },

    methods: {
        getAsyncData: debounce(function getAsyncData(name) {
            if (!name.length) {
                this.data = [];
                return;
            }
            this.isFetching = true;

            axios
                .get(`/api/courses?search=${name}&per_page=50`)
                .then(({ data }) => {
                    this.data = [];
                    if (data && data.data && Array.isArray(data.data)) {
                        data.data.forEach(item => this.data.push(item));
                    }
                })
                .catch(error => {
                    this.data = [];
                    console.error('Error searching courses:', error);
                })
                .finally(() => {
                    this.isFetching = false;
                });
        }, 500),
    },
};
</script>
